import React, { useState } from 'react';
import ContactForm from "../ContactForm"
import Footer from "../Footer"
import "../../App.css"


const Contact = () => {
    return (
    <>
        <ContactForm />
        <Footer />
    </>
    )
}

export default Contact